module.exports = __webpack_public_path__ + "img/lelele3x.80a43374.png";